import { render, staticRenderFns } from "./BranchCommon.vue?vue&type=template&id=0da1c14e&scoped=true"
import script from "./BranchCommon.vue?vue&type=script&lang=js"
export * from "./BranchCommon.vue?vue&type=script&lang=js"
import style0 from "./BranchCommon.vue?vue&type=style&index=0&id=0da1c14e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da1c14e",
  null
  
)

export default component.exports